import { createTheme } from "@mui/material/styles";

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1976d2", // Customize your primary color for light theme
      alt: "#90caf9",
    },
    background: {
      default: "#f4f6f8", // Light background
      alt: "#121212",
      boxShadow: "0 0 1rem rgba(0, 0, 0, 0.2)",
    },
  },
});

const darkTheme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#90caf9", // Customize your primary color for dark theme
      alt: "#1976d2",
    },
    background: {
      default: "#121212", // Dark background
      alt: "#f4f6f8",
      boxShadow: "0 0 1rem rgba(255, 255, 255, 0.2)",
    },
  },
});

const accentColours = {
  dodgerBlue: "#1E90FF",
  teal: "#008080",
  fireBrick: "#B22222",
  gold: "#FFD700",
  darkSlateGray: "#2F4F4F",
};

const getAccentTheme = (baseTheme, accentColour) =>
  createTheme({
    ...baseTheme,
    palette: {
      ...baseTheme.palette,
      primary: {
        main: accentColour || baseTheme.palette.primary.main, // Use accent color as primary
      },
    },
  });

export { lightTheme, darkTheme, accentColours, getAccentTheme };
